// extracted by mini-css-extract-plugin
export default {"language":"GameLiveLanguage__language--3aH"};